<mat-tab-group #matTabGroup mat-align-tabs="center" (selectedTabChange)="onActiveTabChange($event.index)">
    <mat-tab label="{{'Afficher par chantier' | translate}}">
    </mat-tab>
    <mat-tab label="{{'Afficher par contrat' | translate}}">
    </mat-tab>
    <mat-tab label="{{'Afficher par bon de livraison' | translate}}">
    </mat-tab>
    <mat-tab label="{{'Afficher par étiquette' | translate}}">
    </mat-tab>
</mat-tab-group>

<app-tab-certificate #Certificats></app-tab-certificate>
